






import Vue from "vue";
import UsageHistory from "@/components/templates/UsageHistory/index.vue";
import testData from "@/shared/testData.js";

export default Vue.extend({
  components: { UsageHistory },
  data() {
    return {
      usageHistoryList: testData.usageHistory,
    };
  },
  methods: {
    handleOnSearch(val: any) {
      this.$emit("getUsageHistory", val);
    },
  },
});
